import { configureStore } from '@reduxjs/toolkit';
import { conversationReducer } from './features/conversation/conversation-slice';
import { dashboardReducer } from './features/dashboard/dashboard-slice';
import { budgetReducer } from './features/budget/budget-slice';
import { PartnersReducer } from './features/partners/partners-slice';
import { quotationReducer } from './features/quotation/quotation-reply-slice';
import { answerQuotationReducer } from './features/answerQuotation/answer-quotation';
import { openModalReducer } from './features/modalLanginPage/openModal';
import { colorActiveHeaderLanding } from './features/modalLanginPage/color';
import { orderServicesReducer } from './features/orderService/orderService-slice';

export const store = configureStore({
  reducer: {
    dashboard: dashboardReducer,
    orderServices: orderServicesReducer,
    conversations: conversationReducer,
    budget: budgetReducer,
    partners: PartnersReducer,
    openModalRegister: openModalReducer,
    activeColor: colorActiveHeaderLanding,
    quotationReducer,
    answerQuotationReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
